import { Button, Radio } from 'antd';
import React, { useState } from 'react';
import { EnumRange } from '../../data';
import styles from './createbox.module.scss';
import { getIn18Text } from 'api';
export const RangeContent = ({ onConfirm, onCancel, item, onChange, updateThisText = getIn18Text('JINGENGXINBENCI'), updateAllText = getIn18Text('GENGXINQUANBURI'), updateThisAndFutureText = getIn18Text('GENGXINBENCIJI'), okText = getIn18Text('QUEDING'), cancelText = getIn18Text('QUXIAO'), defaultRange = EnumRange.THIS, hideAll = false, hideThis = false, hideThisAndFuture = false, hideButton = false, }) => {
    const [value, setValue] = useState(hideThis ? EnumRange.ALL : defaultRange);
    const handleChange = (e) => {
        const { value } = e.target;
        setValue(value);
        if (onChange) {
            onChange(value);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.confirmCheckBox },
            React.createElement(Radio.Group, { onChange: handleChange, value: value },
                !hideThis && (React.createElement(Radio, { style: { display: 'block' }, value: EnumRange.THIS }, updateThisText)),
                !hideThisAndFuture && (React.createElement(Radio, { style: { display: 'block' }, value: EnumRange.THIS_AND_FUTURE }, updateThisAndFutureText)),
                !hideAll && (React.createElement(Radio, { style: { display: 'block' }, value: EnumRange.ALL }, updateAllText)))),
        !hideButton && (React.createElement("div", { className: styles.confirmButtons },
            React.createElement(Button, { onClick: () => onCancel && onCancel() }, cancelText),
            React.createElement(Button, { type: "primary", onClick: () => onConfirm && onConfirm(value) }, okText)))));
};
